import { omit } from "lodash";

//公共过滤styleParam
export const yxStyleProps = (props, ...arg) =>
  omit(props, ["styleParam", ...arg]);

/**
 * 过滤 yxButtom 组件 参数
 * @param props :object
 */
export const yxBtnProps = (props) =>
  omit(props, ["styleParam", "dropDown", "iconfont", "inputParams"]);

/**
 * 过滤 YxText.Time 组件 参数
 * @param props :object
 */
export const yxTextIimeProps = (props) => omit(props, ["isTimeZone"]);

/**
 * 过滤 YxText.Img 组件 参数
 * @param props :object
 */
export const yxTextImgProps = (props) => omit(props, ["styleParam", "onlySee"]);
/**
 * 过滤 YxText.String 组件 参数
 * @param props :object
 */
export const yxTextStrProps = (props) =>
  omit(props, [
    "replaceStrLength",
    "replaceStr",
    "replaceAppointStr",
    "replaceStrLength",
    "isReplace",
    "replaceType",
    "replaceLength",
  ]);

/**
 * 过滤 YxText.Number 组件 参数
 * @param props :object
 */
export const yxTextNumProps = (props) =>
  omit(props, [
    "amountTypeExtra",
    "isThousand",
    "precision",
    "isRounding",
    "afterStrClass",
    "beforeStrClass",
    "isShowSymbolAfter",
    "isShowSymbolBefore",
    "amountType",
  ]);
/**
 * 过滤 YxAction 组件 参数
 * @param props :object
 */
export const yxActionProps = (props, ...args) =>
  omit(props, [
    "dataIndex",
    "styleType",
    "iocParam",
    "factory",
    "model",
    "validateModel",
    "requestParam",
    "popconfirmParam",
    "isConfirm",
    "actionType",
    "jumpType",
    "validateCallback",
    "beforeClick",
    "staticContext",
    "afterClick",
    "ids",
    "validateOptions",
    "timeOut",
    "path",
    "popupParam",
    "extraTypeList",
    "message",
    "popup",
    "downConfig",
    "check",
    ...args,
  ]);

/**
 * 过滤 YxTable 组件参数(作用与tr,td,th 出现的warning)
 * @param props :object
 */
export const yxTableProps = (props, ...args) =>
  omit(props, [
    "allParam",
    "EventEmitter",
    "isTitps",
    "controlType",
    "editKey",
    "styleParam",
    "handleSave",
    "dataIndex",
    "EventEmitter",
    "tableId",
    "editable",
    "onResize",
    "globalProps",
    ...args,
  ]);



// WEBPACK FOOTER //
// ./src/yx-widget/utils/filterProps.js